import React from 'react';

export const AxisBottom = ( {x, innerHeight } ) => (
  x.ticks().map(tickValue => (
    <g key={tickValue} transform={`translate(${x(tickValue)},0)`}>
      <text
        className="tick-label"
        key={tickValue}
        style={{textAnchor: 'middle'}} 
        dy=".71em"
        y={innerHeight+3}
      >{tickValue}</text>
    </g>
  ))
);

